import type { ApiClient } from "./client";
import type { FollowupCatchUpInput, FollowupCatchUpResult, FollowupSettingsValue, FollowupSettingsView } from "./types";

/** Follow-up settings and rules: global (organizationId null) and per organization. */
export interface FollowupsApi {
  get(organizationId: string | null): Promise<FollowupSettingsView>;
  /** This scope's own settings (an organization stops inheriting global). */
  update(organizationId: string | null, settings: FollowupSettingsValue): Promise<FollowupSettingsView>;
  /** Drop this scope's own settings: an organization inherits global, global the built-in defaults. */
  reset(organizationId: string | null): Promise<FollowupSettingsView>;
  /** Leads that went quiet before follow-ups: a preview (dryRun) or the follow-ups planned. */
  catchUp(input: FollowupCatchUpInput): Promise<FollowupCatchUpResult>;
}

export function createHttpFollowupsApi(client: ApiClient): FollowupsApi {
  return {
    get: (organizationId) =>
      organizationId ? client.call("getOrganizationFollowupSettings", { params: { id: organizationId } }) : client.call("getFollowupSettings"),
    update: (organizationId, settings) =>
      organizationId
        ? client.call("updateOrganizationFollowupSettings", { params: { id: organizationId }, body: { settings } })
        : client.call("updateFollowupSettings", { body: { settings } }),
    reset: (organizationId) =>
      organizationId ? client.call("resetOrganizationFollowupSettings", { params: { id: organizationId } }) : client.call("resetFollowupSettings"),
    catchUp: (input) => client.call("catchUpFollowups", { body: input }),
  };
}
